
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"#fff","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_106_1592)"}},[_c('path',{attrs:{"d":"M11.608 20h-8.12A3.49 3.49 0 010 16.52V8.415a3.49 3.49 0 013.488-3.481h8.12a3.49 3.49 0 013.488 3.481v8.104a3.49 3.49 0 01-3.488 3.482zM3.488 6.47c-1.076 0-1.95.87-1.95 1.945v8.104c0 1.075.874 1.946 1.95 1.946h8.12c1.077 0 1.95-.871 1.95-1.946V8.415a1.948 1.948 0 00-1.95-1.946h-8.12z"}}),_c('path',{attrs:{"d":"M16.827 16.48a.77.77 0 01-.77-.769V7.968a4.043 4.043 0 00-4.042-4.034H4.258a.77.77 0 01-.77-.768.77.77 0 01.77-.768h7.757c3.077 0 5.581 2.5 5.581 5.57v7.743a.77.77 0 01-.77.768z"}}),_c('path',{attrs:{"d":"M19.232 13.397a.77.77 0 01-.77-.767V7.39c0-3.229-2.63-5.854-5.865-5.854h-5.25a.77.77 0 01-.769-.768.77.77 0 01.77-.768h5.25C16.681 0 20 3.317 20 7.39v5.24a.77.77 0 01-.769.767zM10.12 13.235H4.68c-.374 0-.68-.346-.68-.768 0-.422.306-.768.68-.768h5.44c.374 0 .68.346.68.768 0 .422-.306.768-.68.768z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_106_1592"}},[_c('path',{attrs:{"d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    